import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/motion.css";
import "./styles/components.css";
import "./styles/landing.css";
import "./styles/print.css";
import "./lib/print";
import { App } from "./App";

const host = document.getElementById("root");
if (!host) throw new Error("no #root element in index.html");

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
